import { render, staticRenderFns } from "./BnfcrDtl.vue?vue&type=template&id=3aae0776&"
import script from "./BnfcrDtl.vue?vue&type=script&lang=js&"
export * from "./BnfcrDtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports